export const defaultTrafficBrowser = () => {
  return [
    [
      '-',
      '-',
      '-',
      '-',
      '-',
      '-'
    ],
    [
      '-',
      '-',
      '-',
      '-',
      '-',
      '-'
    ],
    [
      '-',
      '-',
      '-',
      '-',
      '-',
      '-'
    ]
  ]
}

export const defaultTrafficBrowserSummary = () => {
  return 'n/a on n/a'
}

export const defaultTrafficDevices = () => {
  return [
    [
      '-',
      '-',
      '-',
      '',
      '-',
      '-'
    ],
    [
      '-',
      '-',
      '-',
      '',
      '-',
      '-'
    ],
    [
      '-',
      '-',
      '-',
      '',
      '-',
      '-'
    ]
  ]
}

export const defaultTrafficDevicesSummary = () => {
  return 'n/a'
}

export const defaultTrafficLocation = () => {
  return [
    [
      '-',
      '-',
      '-',
      '-',
      '-',
      '-'
    ],
    [
      '-',
      '-',
      '-',
      '-',
      '-',
      '-'
    ],
    [
      '-',
      '-',
      '-',
      '-',
      '-',
      '-'
    ]
  ]
}

export const defaultTrafficLocationSummary = () => {
  return 'n/a'
}

export const defaultTrafficMap = () => {
  return {
    geoData: [
      ['State', 'Sessions'],
      [
        'California',
        {
          v: 0,
          f: '0'
        }
      ]
    ],
    geoOptions: {
      colorAxis: { colors: ['#c6ece0', '#21ce99'] },
      legend: {
        numberFormat: '###,###'
      },
      is3D: false,
      region: 'US',
      resolution: 'provinces'
    }
  }
}

export const defaultTrafficSources = () => {
  return [
    [
      '-',
      '-',
      '-',
      '',
      '-',
      '-'
    ],
    [
      '-',
      '-',
      '-',
      '',
      '-',
      '-'
    ],
    [
      '-',
      '-',
      '-',
      '',
      '-',
      '-'
    ]
  ]
}

export const defaultTrafficSourcesSummary = () => {
  return 'n/a'
}

export const defaultTrafficVisitors = () => {
  return [
    { name: 'Visitors', amount: 0, type: 'int' },
    { name: 'Sessions', amount: 0, type: 'int' },
    { name: 'Average Time on Page', amount: '0 sec.', type: 'string' },
    { name: 'Conversion Rate', amount: 0, type: 'int' },
    { name: 'Page Load Speed', amount: '0 sec.', type: 'string' }
  ]
}

export const defaultTrafficVisitorsSummary = () => {
  return '0%'
}



// WEBPACK FOOTER //
// ./src/js/utils/helpersProductDetailStats.js